import { render, staticRenderFns } from "./TwitterVerify.vue?vue&type=template&id=53c778fb&scoped=true&"
import script from "./TwitterVerify.vue?vue&type=script&lang=js&"
export * from "./TwitterVerify.vue?vue&type=script&lang=js&"
import style0 from "./TwitterVerify.vue?vue&type=style&index=0&id=53c778fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c778fb",
  null
  
)

/* custom blocks */
import block0 from "./TwitterVerify.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports